import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { cn } from '../../utils/cn';
interface AccordionItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function AccordionItem({
  question,
  answer,
  isOpen,
  onClick
}: AccordionItemProps) {
  return <div className="border border-line rounded-2xl bg-surface overflow-hidden mb-4" data-id="element-332" data-mp="2ocm94er1w02f">
      <button type="button" className="w-full px-6 py-5 flex items-center justify-between text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pistachio-500" onClick={onClick} aria-expanded={isOpen} data-id="element-333" data-mp="3c2gl6u3jpklm">
        <span className="font-semibold text-base sm:text-lg pr-8 text-ink" data-id="element-334" data-mp="378ltb3dsdzbg">{question}</span>
        <div className={cn('flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors', isOpen ? 'bg-pistachio-400 text-pistachio-900' : 'bg-pistachio-100 text-pistachio-700')} aria-hidden="true" data-id="element-335" data-mp="3uyzq177bgmcd">
          {isOpen ? <MinusIcon size={18} data-id="element-336" data-mp="2wzrpz66n2srt" /> : <PlusIcon size={18} data-id="element-337" data-mp="2wwccg7sm5rsi" />}
        </div>
      </button>
      <AnimatePresence initial={false} data-id="element-338" data-mp="3bnuz2ofzakku">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-339" data-mp="36vutogh52zgv">
            <div className="px-6 pb-6 pt-0 text-muted leading-relaxed" data-id="element-340" data-mp="3glmpfe0z5ymx">{answer}</div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
interface AccordionProps {
  items: {
    question: string;
    answer: string;
  }[];
}
export function Accordion({
  items
}: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="w-full max-w-3xl mx-auto" data-id="element-341" data-mp="1v9d0ka7004mi">
      {items.map((item, index) => <AccordionItem key={item.question} question={item.question} answer={item.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-342" data-mp="3vbchu2hi7lw2" data-mpi={index} />)}
    </div>;
}